import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Hooks typés pour une meilleure expérience développeur
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Hook personnalisé pour les actions asynchrones avec gestion d'erreur
export const useAsyncAction = () => {
  const dispatch = useAppDispatch();
  
  const executeAsync = async <T>(
    asyncThunk: any,
    onSuccess?: (result: T) => void,
    onError?: (error: string) => void
  ) => {
    try {
      const result = await dispatch(asyncThunk);
      if (asyncThunk.fulfilled.match(result)) {
        onSuccess?.(result.payload);
        return result.payload;
      } else if (asyncThunk.rejected.match(result)) {
        const error = result.payload as string || 'Une erreur est survenue';
        onError?.(error);
        throw new Error(error);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Une erreur est survenue';
      onError?.(errorMessage);
      throw error;
    }
  };

  return { executeAsync };
};

// Hook pour l'état d'authentification
export const useAuth = () => {
  const authState = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  return {
    ...authState,
    dispatch,
  };
};

// Hook pour l'état des agents
export const useAgents = () => {
  const agentsState = useAppSelector((state) => state.agents);
  const dispatch = useAppDispatch();

  return {
    ...agentsState,
    dispatch,
  };
};

// Hook pour l'état de l'UI
export const useUI = () => {
  const uiState = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();

  return {
    ...uiState,
    dispatch,
  };
};
